import { css } from '@emotion/css';

export const disabledCheckbox = css`
  opacity: 0.3;
`;
